import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

import { APISD } from "../../../../../../../../config/apisd";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";


const initialForm = {
  name_fase: "",
  description: "",
};

export default function ModalFaseAdd(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    if (props.show) {
      setForm(initialForm);
      setIsSubmitting(false);
    }
  }, [props.show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APISD.post(
        "/api/fases/store",
        {
          name_fase: form.name_fase.trim(),
          description: form.description.trim(),
          user_id: idUser,
        },
        fetchParams
      );

      if (response?.status === 200 || response?.status === 201) {
        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data fase berhasil ditambahkan",
        });

        await props.GetResponseData?.();
        props.onHide?.();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal menambahkan data fase",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-tambah-fase"
    >
      <form onSubmit={handleSubmit}>
        <div className="sims-modal-header">
          <div>
            <h5 id="modal-tambah-fase" className="sims-modal-title">Tambah Fase</h5>
           
          </div>

          <button
            type="button"
            className="sims-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="sims-modal-body mt-1 mx-2">
          <div className="sims-form-grid">
            <div className="sims-form-group sims-form-span-2">
              <label className="sims-form-label" htmlFor="add-name-fase">
                Nama Fase <span>*</span>
              </label>

              <input
                id="add-name-fase"
                className="sims-form-input"
                type="text"
                name="name_fase"
                value={form.name_fase}
                onChange={handleChange}
                autoComplete="off"
                required
              />
            </div>

            <div className="sims-form-group sims-form-span-2">
              <label
                className="sims-form-label"
                htmlFor="add-description"
              >
                Deskripsi <span>*</span>
              </label>

              <textarea
                id="add-description"
                className="sims-form-textarea"
                name="description"
                value={form.description}
                onChange={handleChange}
                rows="4"
                required
              />
            </div>
          </div>
        </Modal.Body>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >

            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Menyimpan...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />
                <span>Tambahkan</span>
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
}
